import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddressesComponent } from './addresses/addresses.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { MedicalComponent } from './medical/medical.component';
import { PatientComponent } from './patient/patient.component';
import { ProfileComponent } from './profile.component';
import { PaymentComponent } from './payment/payment.component';

const routes: Routes = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      { path: 'patient', component: PatientComponent, data: { title: 'Patient Profile | Account Details' } },
      { path: 'medical', component: MedicalComponent, data: { title: 'Patient Profile | Medical History' } },
      { path: 'insurance', component: InsuranceComponent, data: { title: 'Patient Profile | Insurance' } },
      { path: 'addresses', component: AddressesComponent, data: { title: 'Patient Profile | Addresses' } },
      { path: 'payment', component: PaymentComponent },
      { path: '**', redirectTo: 'patient' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
